<template>
    <div :class='props.theme.wrapper'>
        <nav :class='props.theme.nav'>

            <ul v-show="props.showPagination" :class="props.theme.list" class='cursor-pointer'>

                <li v-if="props.hasEdgeNav" class="page-item" @click="props.setFirstPage">
                    <a class="page-link" v-bind="props.firstPageProps">{{props.texts.first}}</a>
                </li>

                <li v-if="props.hasChunksNav" class="page-item" @click="props.setPrevChunk">
                    <a class="page-link" v-bind="props.prevChunkProps">{{props.texts.prevChunk}}</a>
                </li>

                <li class="page-item" @click="props.setPrevPage">
                    <a class="page-link" v-bind="props.prevProps">{{props.texts.prevPage}}</a>
                </li>

                <li v-for="page in props.pages" :key="page" :class="props.pageClasses(page)" v-on="props.pageEvents(page)">
                     <a class="page-link" v-bind="props.aProps">{{page}}</a>
                </li>

                <li class="page-item"  @click="props.setNextPage">
                    <a class="page-link" v-bind="props.nextProps">{{props.texts.nextPage}}</a>
                </li>

                <li v-if="props.hasChunksNav" class="page-item"  @click="props.setNextChunk">
                    <a class="page-link" v-bind="props.nextChunkProps">{{props.texts.nextChunk}}</a>
                </li>

                <li v-if="props.hasEdgeNav" class="page-item"  @click="props.setLastPage">
                    <a class="page-link" v-bind="props.lastPageProps">{{props.texts.last}}</a>
                </li>

            </ul>
        </nav>
    </div>

</template>

<script>
    export default {
        name: 'MyPagination',
        props: ['props']
    }
</script>

<style lang="scss">
.pagination {
    display: flex; 
    justify-content: center;
    gap: 10px;
    text-align: center;

    @media (max-width: 768px) {
        margin-bottom: 60px;
        margin-top:20px;
    }
}


.page-item{
    width: 20px;
    height: 20px;
    background-color: #ced4da;
    list-style-type: none;
    cursor: pointer;
    padding: 10px;
}

.page-item.active{
    background-color: var(--primary-colour-1);
    color: #e9ecef;
}

</style>